import { render } from "./EditingCore.vue?vue&type=template&id=042a6d5d"
import script from "./EditingCore.vue?vue&type=script&lang=js"
export * from "./EditingCore.vue?vue&type=script&lang=js"
script.render = render

export default script